import { OrderDetail } from '@/modules/orders/types';
import { Product } from '@/modules/products/types';

const repeatAndNotRepeatProductsByOrderDetails = (ordersDetails: OrderDetail[]) => {
  const setProducts = new Set(ordersDetails.map((orderDetail) => orderDetail.product));

  const groupOrderDetailsByProducts: OrderDetail[][] = [...setProducts].map((product) =>
    repeatProductArray(ordersDetails, product)
  );
  const notRepeatProducts = groupOrderDetailsByProducts
    .filter((groupProducts: OrderDetail[]) => groupProducts.length === 1)
    .map((arrayWithOneOrderDetail) => arrayWithOneOrderDetail[0]);
  const repeatProduct = groupOrderDetailsByProducts.filter(
    (productsRepeat: OrderDetail[]) => productsRepeat.length > 1
  );
  return {
    notRepeatProducts,
    repeatProduct,
  };
};

const repeatProductArray = (array: OrderDetail[], product: Product) =>
  array.filter((element) => element.product.id === product.id);

export const groupsOrdersDetailsWithProducts = (ordersDetails: OrderDetail[]) => {
  const { notRepeatProducts, repeatProduct } =
    repeatAndNotRepeatProductsByOrderDetails(ordersDetails);

  const ordersDetailsByProducts = notRepeatProducts;
  const ordersDetailsRepeatInOne = repeatProduct.map((ordersRepeat: OrderDetail[]) => ({
    ...ordersRepeat[0],
    quantity: ordersRepeat.reduce(
      (stack, orderRepeat) => stack + orderRepeat.quantity + orderRepeat.quantity_discount,
      0
    ),
  }));
  return ordersDetailsByProducts.concat(ordersDetailsRepeatInOne);
};
